module.exports = __webpack_public_path__ + "static/img/main1.0dc0777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/programme/main1.png
// module id = xuXB
// module chunks = 1